/* eslint-disable max-lines-per-function */
/**
 * @file  Documents
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useContext, useCallback} from 'react';
import {Button, Table, Divider} from 'antd';
import Iconfont from '~/component/Iconfont';
import {BasicLayoutContext} from '~/layout/BasicLayout';
import {isIOS} from '~/utils/device';
import {downloadFile} from '~/utils/function';

import './index.less';

const columns = [
    {
        title: '',
        dataIndex: 'blank',
        key: 'blank',
        width: 153,
    },
    {
        title: 'Audit Committee',
        dataIndex: 'audit',
        key: 'audit',
        width: 183,
    },
    {
        title: 'Compensation Committee',
        dataIndex: 'compensation',
        key: 'compensation',
        width: 183,
    },
    {
        title: 'Nominating and Corporate Governance Committee',
        dataIndex: 'nominating',
        key: 'nominating',
        width: 193,
    },
];

const data = [
    {
        key: '1',
        // eslint-disable-next-line react/jsx-one-expression-per-line
        blank: <div><div>Larry</div><div>Xiangdong Chen</div></div>,
        audit: '-',
        compensation: '-',
        nominating: '-'
    },
    {
        key: '2',
        blank: 'Jin Cui',
        audit: <img src="//i.gsxcdn.com/1181283949_cat1a4by.png" alt="chair"></img>,
        compensation: <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="member"></img>,
        nominating: <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="member"></img>
    },
    {
        key: '3',
        blank: 'Yiming Hu',
        audit: <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="member"></img>,
        compensation: <img src="//i.gsxcdn.com/1181283949_cat1a4by.png" alt="chair"></img>,
        nominating: <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="member"></img>
    },
    {
        key: '4',
        blank: 'Hao Sun',
        audit: <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="member"></img>,
        compensation: <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="member"></img>,
        nominating: <img src="//i.gsxcdn.com/1181283949_cat1a4by.png" alt="chair"></img>
    },
];

function Documents() {
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    // 下载PDF文件
    const downloadPdfFile = useCallback(
        event => {
            const {url, name} = event?.currentTarget?.dataset || {};
            if (url) {
                downloadFile(url, `${name}.pdf`);
            }
        },
        [],
    );

    return (
        <div className="documents-content">
            {
                isMobile && (
                    <div className="documents-content-title">
                        Governance Documents
                    </div>
                )
            }
            <div className="documents-intro">
                Gaotu Techedu Inc. has the committees listed below in place.
                The grid below provides an overview of the individuals that
                make up each committee.  To learn more about a particular
                committee or an individual member click the titles below.
            </div>
            {
                !isMobile && (
                    <div className="documents-title">Title</div>
                )
            }

            {
                isMobile
                    ? (
                        <>
                            <div className="documents-file-m">
                                <Divider />
                                <div className="documents-file-btns">
                                    <div className="documents-file-icon-name">
                                        <Iconfont type="iconword" className="iconword" />
                                        <div className="documents-file-name">Audit Committee Charter</div>
                                    </div>

                                    <a href="//p.gsxcdn.com/1638084672_s6a6vdoe.pdf">
                                        <Button
                                            type="text"
                                            className="documents-btn"
                                            icon={
                                                <Iconfont type="iconxiazai-M" className="iconxiazai-m" />
                                            }
                                        />
                                    </a>
                                </div>

                                <Divider />
                                <div className="documents-file-btns">
                                    <div className="documents-file-icon-name">
                                        <Iconfont type="iconword" className="iconword" />
                                        <div className="documents-file-name">
                                            Business Conduct and Ethics
                                        </div>
                                    </div>

                                    <a href="//p.gsxcdn.com/1638097165_av07joqd.pdf">
                                        <Button
                                            type="text"
                                            className="documents-btn"
                                            icon={
                                                <Iconfont type="iconxiazai-M" className="iconxiazai-m" />
                                            }
                                        />
                                    </a>
                                </div>

                                <Divider />

                                <div className="documents-file-btns">
                                    <div className="documents-file-icon-name">
                                        <Iconfont type="iconword" className="iconword" />
                                        <div className="documents-file-name">
                                            Compensation Committee Charter
                                        </div>
                                    </div>

                                    <a href="//p.gsxcdn.com/1638097621_sejwor1p.pdf">
                                        <Button
                                            type="text"
                                            className="documents-btn"
                                            icon={
                                                <Iconfont type="iconxiazai-M" className="iconxiazai-m" />
                                            }
                                        />
                                    </a>
                                </div>

                                <Divider />

                                <div className="documents-file-btns documents-file-last">
                                    <div className="documents-file-icon-name">
                                        <Iconfont type="iconword" className="iconword" />
                                        <div className="documents-file-name documents-file-name-last">
                                            Nominating and Corporate Governance Committee Charter
                                        </div>
                                    </div>

                                    <a href="//p.gsxcdn.com/1638097844_ozhr9062.pdf">
                                        <Button
                                            type="text"
                                            className="documents-btn"
                                            icon={(
                                                <Iconfont
                                                    type="iconxiazai-M"
                                                    // eslint-disable-next-line react/forbid-component-props
                                                    className={
                                                        isIOS
                                                            ? 'iconxiazai-safari-last'
                                                            : 'iconxiazai-m iconxiazai-m-last'
                                                    }
                                                />
                                            )}
                                        />
                                    </a>
                                </div>

                                <Divider />
                            </div>
                        </>
                    )
                    : (
                        <div className="documents-file">
                            <Button
                                className="documents-btn"
                                onClick={downloadPdfFile}
                                data-url="//p.gsxcdn.com/1638084672_s6a6vdoe.pdf"
                                data-name="Audit Committee Charter"
                                icon={
                                    <Iconfont type="iconword" />
                                }
                            >
                                Audit Committee Charter
                            </Button>

                            <Button
                                className="documents-btn"
                                onClick={downloadPdfFile}
                                data-url="//p.gsxcdn.com/1638097165_av07joqd.pdf"
                                data-name="Business Conduct and Ethics"
                                icon={
                                    <Iconfont type="iconword" />
                                }
                            >
                                Business Conduct and Ethics
                            </Button>

                            <Button
                                className="documents-btn"
                                onClick={downloadPdfFile}
                                data-url="//p.gsxcdn.com/1638097621_sejwor1p.pdf"
                                data-name="Compensation Committee Charter"
                                icon={
                                    <Iconfont type="iconword" />
                                }
                            >
                                Compensation Committee Charter
                            </Button>


                            <Button
                                className="documents-btn"
                                onClick={downloadPdfFile}
                                data-url="//p.gsxcdn.com/1638097844_ozhr9062.pdf"
                                data-name="Nominating and Corporate Governance Committee Charter"
                                icon={
                                    <Iconfont type="iconword" />
                                }
                            >
                                Nominating and Corporate Governance Committee Charter
                            </Button>
                        </div>
                    )
            }

            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                bordered
            />

            <div className="documents-icon">
                <div className="documents-chair">
                    <img src="//i.gsxcdn.com/1181283949_cat1a4by.png" alt="chair"></img>
                    <span>Chair</span>
                </div>
                <div className="documents-member">
                    <img src="//i.gsxcdn.com/1181287269_4hclt7yn.png" alt="member"></img>
                    <span>Member</span>
                </div>

            </div>
        </div>
    );
}

export default Documents;
